import { formatDuration, intervalToDuration } from 'date-fns';

export const durationSecondsToDays = (duration: number) =>  {
  return duration / 86400;
};

const factors = {
  seconds: 1,
  minutes: 60,
  hours: 3600,
  days: 86400,
  weeks: 604800,
  months: 2592000,
  years: 31536000,
};

export const getDurationInUnit = (values: number, unit: keyof typeof factors, operation: 'seconds' | 'custom') => {
  const factor = factors[unit];
  if (!factor) return 0;
  let result = null;

  if(operation === 'seconds') {
    result = values * factor;
  }
  if(operation === 'custom') {
    result = values / factor;
  }

  return isNaN(result as number) ? 0 : result;
};

export const secondsToHumanReadable = (value: string, locale: any) => {
  const seconds = Number(value);
  if (!Number.isFinite(seconds) || seconds < 0) {
    return '';
  }

  if (seconds === 0) {
    return formatDuration(
      { seconds: 0 },
      { locale, format: ['seconds'], zero: true },
    );
  }

  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  const result = formatDuration(duration, { locale });
  return result ?? '0s';
};

export default {
  durationSecondsToDays,
  getDurationInUnit,
  secondsToHumanReadable,
};
